import { createSelector } from '@reduxjs/toolkit'

import { AppRootState } from 'app/store'
import { selectFilters } from 'features/filter'

export const selectExamCards = (state: AppRootState) => state.dashboard.examCards

export const selectTitle = (state: AppRootState, id: string) =>
  state.dashboard.examCards.find(card => card.id === id)?.title

export const selectExamCardsByFilters = createSelector(
  [selectExamCards, selectFilters],
  (examCards, filters) => {
    if (filters.length === 0) return examCards

    return examCards.filter(({ labels = [], level = '', ...card }) => {
      const cardFilters: string[] = [card.category, level, ...labels]

      return filters.every(filter => cardFilters.includes(filter))
    })
  }
)

export const selectDashboardStatus = (state: AppRootState) => state.dashboard.status

export const selectIsInFrame = (state: AppRootState) => state.dashboard.isInFrame
export const selectIdDarkTheme = (state: AppRootState) => state.dashboard.isDarkTheme
